<template>
  <!-- <div id="app"> v-if="isRouterAlive"-->
  <router-view />
  <!-- </div> -->
</template>
<script>
import Watermark from '@/core/watermark'
export default {
  // provide(){
  //   return {
  //     reload:this.reload
  //   }
  // },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  watch: {
    $route(to, from) {
      console.log("监听", to, from);
      if (typeof localStorage.basicInfo != "undefined") {
        document.title = JSON.parse(localStorage.basicInfo).projectName;
      }


      if (
        JSON.parse(localStorage.userInfo) &&
        JSON.parse(localStorage.userInfo).userType == 2
      ){
        this.$nextTick(() => {
          Watermark.set(JSON.parse(localStorage.userInfo).userMobile,null);
        });
        
      }
    },
  },
  created() {},
  async mounted() {
    const handleFontSize = () => {
      // 设置网页字体为默认大小
      WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      // 重写设置网页字体大小的事件
      WeixinJSBridge.on("menu:setfont", function () {
        WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      });
    };
    try {
      // 安卓 禁止用户自定义设置字体大小
      if (
        typeof WeixinJSBridge == "object" &&
        typeof WeixinJSBridge.invoke == "function"
      ) {
        handleFontSize();
      } else {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            handleFontSize,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", handleFontSize);
          document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
        }
      }
    } catch (error) {}

    let a = window.location.protocol;
    let b = window.location.host;
    let url = `${a}//${b}/`;
    localStorage.domainUrl = url;


    
    if (
        JSON.parse(localStorage.userInfo) &&
        JSON.parse(localStorage.userInfo).userType == 2
      ){
        this.$nextTick(() => {
          Watermark.set(JSON.parse(localStorage.userInfo).userMobile,null);
        });
        
      }
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>
<style lang="scss">
body {
  /* IOS 禁止用户自定义设置字体大小 */
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
}
</style>
